const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the embedded video player component
 * @argument {$sce} $sce the resource defined to manage $sce
 */

app.directive('embeddedVideoPlayer', ['$sce', function ($sce) {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      videoLink: '=',
      videoSource: '=',
      videoSourceId: '=',
      videoParams: '=',
      initialView: '@?',
      mediaId: '=?',
      tracking: '=?',
      onComplete: '&?',
      completionPercent: '=?'
    },
    template: require('../../templates/directives/embedded-video-player.html'),
    link: function (scope, element, attrs) {
      var initialize = function() {
        if (!scope.videoLink) return;
        var ratio = (attrs.height / attrs.width) * 100;
        var options = {
          youtube: "https://www.youtube.com/embed/",
          vimeo: "https://player.vimeo.com/video/"
        };

        scope.newLink = options[scope.videoSource] + scope.videoSourceId;
        if (scope.videoSource === 'youtube') {
          scope.newLink += scope.videoParams ? scope.videoParams : '?modestbranding=1&autohide=1&showinfo=0&controls=1&fs=1&rel=0&enablejsapi=1';
        }

        scope.newVideo = $sce.trustAsResourceUrl(scope.newLink);

        element[0].style.paddingTop = ratio + '%';

        scope.$on('pausevideo', function(event, data) {

          var iframe = element[0].querySelector('.embeddedplayer');
          var iframeSrc = iframe.src;

          if (scope.videoSource === 'youtube') {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
          } else {
            iframe.src = iframeSrc;
          }

        });

      };

      scope.$watch('videoSourceId', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          initialize();
        }
      }, true);

      if (scope.videoLink && scope.videoSource && scope.videoSourceId) {
        initialize();
      }
    }
  };

}]);